import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ujrkwby4a: FaireProductEntity = {
  token: "p_7ujrkwby4a",
  type: "product",
  name: "Fragrance Free Head To Toe Wash",
  brandToken: "b_dvnws1tv58",
  brandName: "Zoey Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/2114a9d984d1149266ecb0b0f90d28173e11678b17e4384ebe595b23d90ee9b5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bba6457b5b32abeefa6f6a959913bd87874da8a406749693408488ad3d265aab.png",
    "https://cdn.faire.com/fastly/d3222c21eccfde08285158068813ee9f11258af04607646bbc794a4708259e23.png",
    "https://cdn.faire.com/fastly/c7a522f4143d66c52e6b9ec7a12c4e99fe650aa8a72a33d701180da6e3e885ca.jpeg",
    "https://cdn.faire.com/fastly/d501939e2e2dbe56501069735a526435b5381d418ca57cd8846322aaf5d1abcd.png",
    "https://cdn.faire.com/fastly/5545b2b902acad727ddafc37db1b066c71bcfc50e9146b8c78d1cadef02cff02.png",
    "https://cdn.faire.com/fastly/45b73abafe1bd794b78f54e78a753c433bc96f4386f1420c3d708ab7713c1c56.png",
    "https://cdn.faire.com/fastly/38f07ff55b4cc9aaf45777866670328d4d13ea9c8253c9f42582602518aae5d9.png",
  ],
  priceDollars: 7,
  description:
    "Crafted specifically for baby's delicate skin and hair, this ultra-gentle, tear-free formula provides a soothing cleanse without harsh chemicals, fragrances, or dyes. Our aloe-based formula is pH balanced to work naturally with baby's skin.\n\nOur lightweight wash rinses clean without residue, making bath time simple and stress-free for parents and babies alike. Perfect for daily use from head to toe.\n\n•\tAloe-based gentle formula\n•\tTear-free and pH balanced\n•\tLightweight and rinses clean\n•\tSafe for delicate and sensitive skin\n•\tFragrance-free and dye-free\n•\t2-in-1 convenience\n•\tVegan & cruelty-free\n•\tWinner of Gold Mom’s Choice Award\n•\tProudly made in the USA\n\nLeaping Bunny Certified Cruelty-Free\n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:12.099Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
